const boxShadowV2 = {
  basic10: '0px 0px 80px 0px #E4E8F766',
  basic20: '0px 0px 24px 0px #E4E8F7CC',
  gradient: '5px -7px 26px 0px #8F6FDB24, -5px 7px 25px 0px #53C1DE24',
};

const gradients = {
  primary: 'linear-gradient(90deg, #F3CA4D 0%, #FF989A 42.88%, #CBABFF 94.62%)',
  primaryOpaque:
    'linear-gradient(90deg, rgba(243, 202, 77, 0.5) 0%, rgba(255, 152, 154, 0.5) 42.88%, rgba(203, 171, 255, 0.5) 94.62%), linear-gradient(0deg, #ffffff, #ffffff)',
  secondary:
    'linear-gradient(90deg,#61A6F2 0%, #8F6FDB 25%, #FF5A5E 50%, #F2C94C 100%)',
};

const colorsV2 = {
  black: '#14171F',
  blackHighEmphasis: '#131313',
  blue05: '#EBF1FD',
  blue10: '#D7E3FC',
  blue20: '#AFC6F8',
  blue30: '#88AAF5',
  blue40: '#608DF1',
  blue50: '#2464E7',
  blue60: '#1650CF',
  blue70: '#1743A4',
  blue80: '#0B2866',
  blue90: '#071D4A',
  brandBlue: '#D6E9EB',
  brandLilac: '#DDD8FF',
  brandPink: '#CD74DD',
  brandPurple: '#6A57E3',
  brandRed: '#45192F',
  brandWatermelon: '#FF5A5E',
  brandYellow: '#F0FB96',
  gray05: '#F9FAFB',
  gray10: '#F5F6F9',
  gray20: '#F2F4F7',
  gray30: '#E5E7EB',
  gray40: '#D0D4DC',
  gray50: '#9BA2B0',
  gray60: '#677084',
  gray70: '#4A5264',
  gray80: '#373F51',
  gray90: '#222834',
  gray95: '#1C212B',
  green05: '#E8F6EB',
  green10: '#CFF0D7',
  green20: '#BAE5C8',
  green30: '#8CD4A4',
  green40: '#5EC37F',
  green50: '#089F40',
  green60: '#307F4A',
  green70: '#21713B',
  green80: '#1B4729',
  green90: '#102A19',
  purple05: '#EEEBFF',
  purple10: '#E4E0FF',
  purple20: '#DDD8FF',
  purple30: '#C1B8FF',
  purple40: '#8E7EF1',
  purple50: '#6A57E3',
  purple60: '#4D3AC5',
  purple70: '#3E2F9F',
  purple80: '#2C207D',
  purple90: '#1D135B',
  red05: '#FEF3F2',
  red10: '#FEE4E2',
  red20: '#FECDCA',
  red30: '#FDA29B',
  red40: '#F97066',
  red50: '#F04438',
  red60: '#D92D20',
  red70: '#B42318',
  red80: '#912018',
  red90: '#7A271A',
  white: '#FFFFFF',
  yellow05: '#FFFAEB',
  yellow10: '#FEF0C7',
  yellow20: '#FEDF89',
  yellow30: '#FEC84B',
  yellow40: '#FDB022',
  yellow50: '#F79009',
  yellow60: '#DC6803',
  yellow70: '#B54708',
  yellow80: '#93370D',
  yellow90: '#7A2E0E',
};

/**
 * @package
 */
export const themeV2 = {
  boxShadowV2,
  colorsV2,
  gradients,
};
